import { Pencil } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import { getProfilePictureUrl } from "@/lib/utils";

type Props = {
  imageUrl: string;
  alt: string;
  id: string;
  avatar?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  fallback?: string;
  size?: number;
};

const EditableAvatar = (props: Props) => {
  const { imageUrl, alt, id, fallback, onChange, avatar, size = 150 } = props;

  return (
    <div className="relative mb-3">
      <Avatar
        className="border-4 border-primary rounded-full flex items-center justify-center overflow-hidden"
        style={{ width: `${size}px`, height: `${size}px` }}
      >
        <AvatarImage
          src={avatar ? avatar : getProfilePictureUrl(imageUrl)}
          width={size}
          height={size}
          alt={alt}
        />
        <AvatarFallback>
          {fallback ? (
            fallback
          ) : (
            <div className="rounded-full bg-gray-200 animate-pulse" style={{ width: `${size - 14}px`, height: `${size - 14}px` }} />
          )}
        </AvatarFallback>
      </Avatar>
      <label
        htmlFor={id}
        className="bg-primary text-white absolute bottom-1 right-1 p-1 rounded-full cursor-pointer"
        role="button"
      >
        <Pencil className="h-3 w-3" />
        <input
          type="file"
          id={id}
          className="hidden"
          onChange={onChange}
          accept="image/*"
        />
      </label>
    </div>
  );
};

export default EditableAvatar;
